var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Alert',{attrs:{"show-icon":""}},[_vm._v("你正在申请「"),_c('b',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.tenantInfo.name))]),_vm._v("」项目的工作流，可从右上角切换项目")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }